import { useEffect, useState, useCallback } from "react";
import AdminFleetList from "./AdminFleetList";
import axiosLLInstance from "../../utils/axiosLLInstance";
import AddAdminFleet from "../common/AddAdminFleet";
import { useNavigate, useParams } from "react-router-dom";
import BreadcrumbItems from "../../components/BreadcrumbItems";
import { Pagination, AutoComplete, Input } from "antd";
import { notifyUser } from "../../utils/notifyUser";
import { search } from "../Dashboard/icons";
import { PageSizeOptions } from "../../utils/constants";
import debounce from "lodash.debounce"; // 👈 install this if not already: npm i lodash.debounce

export default function AdminFleets() {
  const [fleets, setFleets] = useState([]);
  const [newFleet, setNewFleet] = useState();
  const [query, setQuery] = useState("");
  const [filteredFleets, setFilteredFleets] = useState([]);
  const { adminId } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotalFleets] = useState(0);
  const [fleetsPerPage, setFleetsPerPage] = useState(PageSizeOptions.pageSize);
  const navigate = useNavigate();

  const getFleets = async (searchQuery = "") => {
    try {
      const { data } = await axiosLLInstance.get(`/fleets/admins/${adminId}`, {
        params: {
          page: currentPage,
          limit: fleetsPerPage,
          q: searchQuery.trim() || undefined,
        },
      });
      setFilteredFleets(data.fleets);
      setFleets(data.fleets);
      setTotalFleets(data.total);
    } catch (error) {
      console.error("Error fetching fleets ", error);
    }
  };

  useEffect(() => {
    getFleets(query);
  }, [currentPage, fleetsPerPage]);

  useEffect(() => {
    if (newFleet) {
      setFleets([...fleets, newFleet]);
      setFilteredFleets([...fleets, newFleet]);
    }
  }, [newFleet]);

  const addNewFleet = (fleet) => {
    setNewFleet(fleet);
  };

  const debouncedSearch = useCallback(
    debounce((val) => {
      getFleets(val);
    }, 500),
    [currentPage, fleetsPerPage]
  );

  const handleChange = (value) => {
    setQuery(value);
    debouncedSearch(value);
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const onSizeChange = (current, page) => {
    setCurrentPage(current);
    setFleetsPerPage(page);
  };

  const onSelect = (fleet) => {
    const selectedFleet = JSON.parse(fleet);
    navigate(
      `/admins/${selectedFleet.admin_id}/fleets/${selectedFleet.id}/devices`
    );
  };

  return (
    <>
      <div className="flex items-center justify-between">
        <BreadcrumbItems
          items={[
            { title: `Manage Admins`, to: `/admins` },
            { title: "Fleets" },
          ]}
        />
        <div className="search-adminBox flex items-center justify-between gap-4">
          <AutoComplete
            style={{ width: 200 }}
            onChange={handleChange}
            value={query}
            onSelect={onSelect}
            className="h-12 w-full border-gray-200"
          >
            <Input
              size="large"
              placeholder="Search Fleets"
              prefix={<img src={search} alt="search icon" />}
            />
          </AutoComplete>
          <AddAdminFleet addNewFleet={addNewFleet} />
        </div>
      </div>

      <AdminFleetList fleets={filteredFleets} />

      {total ? (
        <div className="flex justify-end mt-4">
          <Pagination
            current={currentPage}
            total={total}
            pageSize={fleetsPerPage}
            onShowSizeChange={onSizeChange}
            onChange={paginate}
            showSizeChanger={true}
            pageSizeOptions={PageSizeOptions.options}
          />
        </div>
      ) : null}
    </>
  );
}
